import * as Sentry from '@sentry/browser';
import ReactDOM from 'react-dom/client';

import packageJson from '../package.json';

import { App } from './App';
import type { AppConfig } from './declarations';

async function loadConfigAndRender() {
  // Fetch configuration from config.json
  const response = await fetch(`/config.json?ts=${Date.now()}`, {
    cache: 'no-store',
  });

  const config: AppConfig = await response.json();

  // Set configuration on window object for global access
  window.APP_CONFIG = config;

  if (process.env.NODE_ENV !== 'development' && config.features.SENTRY) {
    Sentry.init({
      dsn: 'https://058d93c5f36b494e81c2c90657a4ee97@alerts.x-lance.ru/2',
      integrations: [],
      tracesSampleRate: 0,
      release: packageJson.version,
      environment: config.env.name,
    });
  }

  // Now render the app
  const rootContainer = document.getElementById('x-lance-root');
  const root = ReactDOM.createRoot(rootContainer);

  root.render(<App />);
}

// Load configuration and render app
loadConfigAndRender();
